import { Component, OnInit, Pipe, PipeTransform } from '@angular/core'
import { AuthService } from '../../services/auth.services'
import { DomSanitizer } from '@angular/platform-browser'

@Pipe({ name: 'safeHtml' })
export class SafeHtmlPipe implements PipeTransform {
    constructor(private sanitized: DomSanitizer) {
    }

    transform(value) {
        return this.sanitized.bypassSecurityTrustHtml(value)
    }
}

@Component({
    selector: 'app-element',
    templateUrl: './appElement.component.html',
    styleUrls: [],
})
export class AppElementComponent implements OnInit {
    en = {}
    showEN = true

    constructor(private auth: AuthService) {
    }

    ngOnInit() {
    }

    changeLanguage() {
        return this.en = this.auth.showLang(this.showEN)
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/appElement.component.ts